import { FormikDatePicker } from "@/components/formcontrols/DatePicker";
import {
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from "@/components/popover/Popover";
import type { FormikProps } from "formik";

import {
  DOKUMENTATION_GAELDER_FRA_LABEL,
  dokumentationGaelderFraInfo,
} from "./dokumentationGaelderFra";

interface DokumentationGaelderFraFeltProps {
  // Felterne i påbuds- og pålægsformularerne er forskellige; dette felt kender kun sit eget.
  formik: FormikProps<any>;
  afgoerelse: "påbud" | "pålæg";
  disabled?: boolean;
}

/**
 * Datofelt med et info-ikon ved labelen. Forklaringen åbnes ved klik, så den også kan
 * læses med tastatur og touch — samme mønster som AiNotePopover.
 */
export const DokumentationGaelderFraFelt = ({
  formik,
  afgoerelse,
  disabled,
}: DokumentationGaelderFraFeltProps) => (
  <FormikDatePicker
    formik={formik}
    disabled={disabled}
    config={{
      component: "datepicker",
      id: "dokumentationGaelderFra",
      label: (
        <span className="d-inline-flex align-items-center gap-1">
          {DOKUMENTATION_GAELDER_FRA_LABEL}
          <PopoverRoot>
            <PopoverTrigger asChild>
              <button
                aria-label={`Hvad betyder ${DOKUMENTATION_GAELDER_FRA_LABEL.toLowerCase()}?`}
                className="c-info-trigger"
                title="Vis forklaring"
                type="button"
              >
                i
              </button>
            </PopoverTrigger>
            <PopoverContent align="start" className="c-info-content small">
              <p className="mb-0">{dokumentationGaelderFraInfo(afgoerelse)}</p>
            </PopoverContent>
          </PopoverRoot>
        </span>
      ),
      initialValue: "",
      isRequired: false,
    }}
  />
);
